import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

import { authState, loadCurrentUser } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/pages/DashboardPage.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: { public: true, plainShell: true },
    component: () => import('@/pages/LoginPage.vue'),
  },
  {
    path: '/password-reset',
    name: 'password-reset-request',
    meta: { public: true, plainShell: true },
    component: () => import('@/pages/PasswordResetRequestPage.vue'),
  },
  {
    path: '/password-reset/:token',
    name: 'password-reset-confirm',
    meta: { public: true, plainShell: true },
    component: () => import('@/pages/PasswordResetConfirmPage.vue'),
  },
  {
    path: '/invitations/:token',
    name: 'invitation-accept',
    meta: { public: true, plainShell: true },
    component: () => import('@/pages/InvitationAcceptPage.vue'),
  },
  {
    path: '/impressum',
    name: 'legal-notice',
    meta: { public: true },
    component: () => import('@/pages/LegalNoticePage.vue'),
  },
  {
    path: '/datenschutz',
    name: 'privacy-policy',
    meta: { public: true },
    component: () => import('@/pages/PrivacyPolicyPage.vue'),
  },
  {
    path: '/users',
    name: 'users',
    meta: { adminOnly: true },
    component: () => import('@/pages/UsersPage.vue'),
  },
  {
    path: '/settings',
    name: 'user-settings',
    component: () => import('@/pages/UserSettingsPage.vue'),
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/pages/ProjectsPage.vue'),
  },
  {
    path: '/plugins',
    name: 'plugins',
    component: () => import('@/pages/PluginsPage.vue'),
  },
  {
    path: '/projects/:id',
    name: 'project-detail',
    component: () => import('@/pages/ProjectDetailPage.vue'),
  },
  {
    path: '/projects/:id/errors/:issueId',
    name: 'project-error-detail',
    component: () => import('@/pages/ErrorDetailPage.vue'),
  },
  {
    path: '/reports',
    name: 'reports',
    meta: { adminOnly: true },
    component: () => import('@/pages/ReportsPage.vue'),
  },
  {
    path: '/documentation/api',
    name: 'api-documentation',
    component: () => import('@/pages/ApiDocumentationPage.vue'),
  },
  {
    path: '/documentation/sdks',
    name: 'sdk-documentation',
    component: () => import('@/pages/SdkDocumentationPage.vue'),
  },
  {
    path: '/documentation/templates',
    name: 'documentation-templates',
    component: () => import('@/pages/DocumentationTemplatesPage.vue'),
  },
  {
    path: '/documentation/concept',
    name: 'concept-documentation',
    meta: { adminOnly: true },
    component: () => import('@/pages/ConceptDocumentationPage.vue'),
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const isLoginRoute = to.name === 'login';
  const isPublicRoute = Boolean(to.meta.public);
  const user = await loadCurrentUser();

  if (!user && !isPublicRoute) {
    return {
      name: 'login',
      query: {
        redirect: to.fullPath,
      },
    };
  }

  if (user && isLoginRoute) {
    return { name: 'dashboard' };
  }

  if (user && to.meta.adminOnly && user.role !== 'admin') {
    return { name: 'dashboard' };
  }

  return true;
});

router.afterEach(() => {
  authState.checked = true;
});
